// @flow
import React, { useState, useEffect } from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

// components
import { VerticalForm, FormInput } from '../../components/';
import AccountLayout from './AccountLayout';

// services
import * as profileActions from '../../redux/actions/profileActions';
import * as profileApi from '../../services/profileApi';
import { isAuthenticated } from '../../services/storageService';

/* bottom link of account pages */
const BottomLink = () => {

    return (
        <Row className="mt-3">
            <Col className="text-center">
                <p className="text-muted">
                    Don't have an account?{' '}
                    <Link to={'/register'} className="text-muted ms-1">
                        <b>Sign Up</b>
                    </Link>
                </p>
            </Col>
        </Row>
    );
};

const ResetPassword = () => {
    let history = useHistory();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated() !== false) {
            history.push('/dsporders');
        }
    }, []);


    const [error, setError] = useState('');

    const schemaResolver = yupResolver(
        yup.object().shape({
            username: yup.string().required('Please enter Username'),
            //password: yup.string().required('Please enter Password'),
        })
    );

    const onSubmit = (formData) => {
        // set loading to true
        setIsLoading(true);

        // go straight to the api and get the response
        profileApi.sendResetToken(formData.username)
            .then((resp) => {

            });



        // dispatch(profileActions.login(formData))
        //     .then((resp) => {
        //         if (resp.data.hasError === true) {
        //             // we have an error
        //             setError(resp.data.message);
        //             setIsLoading(false);

        //         } else {
        //             // we are good to go
        //             setError(''); // clear the error if there are any

        //             // redirect to orders
        //             history.push('/dsporders');
        //         }
        //     });
    };

    const backToLogin = () => {
        history.push('/login');
    }

    return (
        <>
            <AccountLayout bottomLinks={<BottomLink />}>
                <div className="text-center w-75 m-auto">
                    <h4 className="text-dark-50 text-center mt-0 fw-bold">Sign In</h4>
                    <p className="text-muted mb-4">
                        Enter your email address to recieve a password reset.
                    </p>
                </div>

                {error && (
                    <Alert variant="danger" className="my-2">
                        {error}
                    </Alert>
                )}

                <VerticalForm
                    onSubmit={onSubmit}
                    resolver={schemaResolver}
                    defaultValues={{ username: '', password: '' }}>
                    <FormInput
                        label={'Email Address'}
                        type="text"
                        name="username"
                        placeholder={'Enter your Username'}
                        containerClass={'mb-3'}
                    />
                    {/* <FormInput
                        label={'Password'}
                        type="password"
                        name="password"
                        placeholder={'Enter your password'}
                        containerClass={'mb-3'}>
                        <Link to="/forgot-password" className="text-muted float-end">
                            <small>Forgot your password?</small>
                        </Link>
                    </FormInput> */}

                    <div className="mb-3 mb-0 text-center">
                        <Button variant="secondary" onClick={() => backToLogin()}>
                            {isLoading === true ? 'Please wait.....' : 'Back To Login'}
                        </Button>{' '}
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading === true ? 'Please wait.....' : 'Send Reset Email'}
                        </Button>
                    </div>
                </VerticalForm>
            </AccountLayout>

        </>
    );
};

export default ResetPassword;